import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'tiktok-third-party-glyph-icon'

export function TikTokSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M30.02 8.024A8.05 8.05 0 0 1 25.156 6.4 8.07 8.07 0 0 1 21.94.024h-5.217V14.28l-.006 7.808a4.722 4.722 0 0 1-3.244 4.48 4.746 4.746 0 0 1-1.752.233 4.702 4.702 0 0 1-2.16-.663 4.722 4.722 0 0 1-2.309-3.978 4.726 4.726 0 0 1 4.732-4.791c.52 0 1.02.085 1.49.239V12.31a10.27 10.27 0 0 0-1.505-.111c-2.887 0-5.587 1.2-7.517 3.362a9.786 9.786 0 0 0-2.469 5.903 9.774 9.774 0 0 0 2.911 7.615 10.005 10.005 0 0 0 7.074 2.896c.509 0 1.011-.038 1.505-.11a9.971 9.971 0 0 0 5.57-2.786 9.767 9.767 0 0 0 2.93-6.95l-.027-11.66a13.18 13.18 0 0 0 2.93 1.708c1.637.69 3.373 1.04 5.159 1.04V8.023c.001.001-.014.001-.015.001Z" />
    </symbol>
  )
}

const TikTokStandaloneContent = standalone(TikTokSymbol, ID)

export const Tiktok = styled(function TikTokStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-tiktok">
      <TikTokStandaloneContent />
    </Icon>
  )
})``

export const TikTokLightweight = styled(function TikTokComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-tiktok">
      {lightweight(ID)}
    </Icon>
  )
})``
